import cmp from '../../lib/cmp';
import smSectionText from '../sm-landing-appstore-app-1-section-text/sm-landing-appstore-app-1-section-text';
import selectByClass from '../../lib/dom/select-by-class';
import trackWhatsNewView from '../../lib/track-event/whats-new-block-view';
import { one } from '../../lib/dom/on';
import './sm-landing-appstore-app-1-whats-new.less';
import { isRtl } from '../../lib/document-dir-utils';



const WHATS_NEW_AREA_CLASS = 'sm-landing-appstore-app-1-whats-new__text-wr';

export default cmp(null, ($cmp, { text, date, version }) => {
  return `
    <div class="sm-landing-appstore-app-1-whats-new">
      <div class="sm-landing-appstore-app-1-whats-new__h">
        <div class="sm-landing-appstore-app-1-whats-new__h-main">${__('sm@_whats_new')}</div>
      </div>
      <div class="sm-landing-appstore-app-1-whats-new__in">
        <div class="sm-landing-appstore-app-1-whats-new__title${isRtl() ? '-rtl' : ''}">
          <div class="sm-landing-appstore-app-1-whats-new__title-main${isRtl() ? '-rtl' : ''}">${__('sm@_version')} ${version}</div>
          <div class="sm-landing-appstore-app-1-whats-new__title-second${isRtl() ? '-rtl' : ''}">${date}</div>
        </div>
        <div class="${WHATS_NEW_AREA_CLASS}">
          ${$cmp('sm-landing-appstore-app-1-whats-new__text', smSectionText, { text })}
        </div>
      </div>
    </div>
  `;
}, (element) => {

  one(selectByClass(element, WHATS_NEW_AREA_CLASS), 'click', () => {
    trackWhatsNewView();
  });
});



// WEBPACK FOOTER //
// ./src/landing-appstore-app-1/sm-landing-appstore-app-1-whats-new/sm-landing-appstore-app-1-whats-new.js